export default `---
slug: reinforcement-learning
title: "Reinforcement Learning"
year: 2021
category: university
featured: false
tags: [Python, Q-Learning, Deep Q-Network, Markov Decision Process, KTH]
thumbnail: /images/projects/9_vecho_RL.png
description: "KTH: landing a rover on the moon with Deep Q-Networks — suuuper boring theory, amazingly fun projects, and a Viking eating spaghetti with Doritos."
relatedLinks:
  - label: "Erasmus @ KTH Stockholm"
    href: /career/erasmus-kth
  - label: "Sales Reinforcer (applied RL)"
    href: /projects/sales-reinforcer
---

![Student with friends doing RL](/images/projects/9_vecho_RL.png)

During my Erasmus in Stokholm, I decided to focus on Machine Learning, and Reinforcement Learning is a must.
The class was taought by [Professor Alexandre Proutiere](https://scholar.google.com/citations?user=g5sya5cAAAAJ&hl=en), who was a great professor, very clear in his explainations, and with the perfect speaking pace to watch the recordings at 2x speed.
The class was an introduction to Reinforcement Learning, so we focused on Markov Decision Processes.
We learned the theory and implementation of Stochastic approximation and Stochastic gradient descent algorithms. We looked at Monte Carlo prediction algorithms, Temporal Difference learning, Q-learning and SARSA with tabular and function approximation.
Toward the end of the class, we also covered Policy gradients and actor-critic algorithms.

![Rover landing gif](/images/projects/9_rover.gif)

As for all the classes I did in KTH, there was a big hands on component: for this class I was together with Stefano, and after an introductory laboratory, we were assigned two projects to do, using my beloved Python + Google Colab (one of the great discoveries of my Erasmus, *together with Mr. Estonius and snus*).

In the first one we practices how to define problems as Markov Decision Processes, code the known algorithms.
In the second project, we were given a simulator of a rover landing on the Moon and we had to implement a Deep Q-Network to control the rover and land it safely.
As for all the other ML projects we did, our limited compute gifted us a lot of time to chat and joke around, and we had a lot of fun.
And when, after 10'000 epochs, we saw the rover consistently landing safely, the feeling was amazing!

To conclude, this class has been *suuuuuper boring* because the theory is just ugh, but man the projects were fun and satisfying!

*And sincle I always conclude with something, here is a picture from the exact night my version of the Q-learning made the rover land:
If you notice, the viking mf is eating spaghetti with Doritos....*

![Martin and Doritos spaghetti](/images/projects/9_Martin.jpg)
`;
